__turbopack_context__.v({
  "container": "AnconContactInformation-module-scss-module__Lino6W__container",
  "webLink": "AnconContactInformation-module-scss-module__Lino6W__webLink",
});
